export default __webpack_public_path__ + "static/media/body_3.e98084bc.png";